export interface FileInputConfig {
  types?: (FileInputType | string)[];
  extensions?: string[];
  multiple?: boolean;
  directory?: boolean;
}

export enum FileInputType {
  imageBasic = 'image/jpeg,image/png',
  imageExtended = 'image/jpeg,image/png,image/gif',
  image = 'image/*',
  audioBasic = 'audio/mp3,audio/mpeg',
  audioExtended = 'audio/mp3,audio/mpeg,audio/wav,audio/x-wav,audio/flac',
  audio = 'audio/*',
  text = 'text/*',
  json = 'application/json',
  pdf = 'application/pdf',
  video = 'video/mp4,video/webm,video/quicktime',
  // video = 'video/mp4,video/mpeg,video/x-m4v,video/*',
}
